import { MenuItem, ListItemIcon, ListItemText, Divider, capitalize } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import type { Subsidiary } from '@vy/types';
import { isEmptyArray } from '@vy/utils';
import { sliceLongString } from '../../../../../utils/string';
import React from 'react';

export type SubsidiariesMenuItemsProps = {
  subsidiaries: Subsidiary[];
};

export const SubsidiariesMenuItems: React.FC<SubsidiariesMenuItemsProps> = ({ subsidiaries }) => {
  if (isEmptyArray(subsidiaries)) {
    return null;
  }

  const MAX_SUBSIDIARY_NAME_LENGTH = 15;

  return (
    <>
      {subsidiaries.map((subsidiary) => (
        <MenuItem
          key={subsidiary.id}
          sx={{
            cursor: 'default',
            '&:hover': {
              backgroundColor: 'transparent',
            },
          }}
        >
          <ListItemIcon sx={{ minWidth: '24px !important' }}>
            <VyIcon icon="HotelBuilding" strokeOpacity={1} color="#7E8796" />
          </ListItemIcon>

          <ListItemText
            slotProps={{
              primary: {
                sx: { color: '#7E8796', fontWeight: 400 },
              },
            }}
          >
            {capitalize(sliceLongString(subsidiary.name, MAX_SUBSIDIARY_NAME_LENGTH))}
          </ListItemText>
        </MenuItem>
      ))}
      <Divider sx={{ my: 1 }} />
    </>
  );
};
